// NPM
/* Load npm scripts here */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// VENDOR
/* Load vendor modules here */
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';

// HELPERS
/* Load helpers here */
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';

// BUNDLES
/* Load bundles here */

// COMPONENTS
/* Load components here */

// PAGE
/* load page specific scripts */

// Init category link block swiper
const seoSliders = document.querySelectorAll('.product-swiper');

if (seoSliders) {
    const swiperConfig = withFocusManagement({
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 16,
        slidesPerView: 1.5,
        breakpoints: {
            380: {
                slidesPerView: 2.5
            },
            769: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 4
            }
        }
    });

    seoSliders.forEach((seoSlider) => {
        // Create new Swiper
        const productSwiper = new Swiper(seoSlider, swiperConfig);

        // Get GTM data attributes
        const gtmCategory = seoSlider.dataset.gtmCategory;
        const gtmAction = seoSlider.dataset.gtmAction;
        const gtmLabel = seoSlider.dataset.gtmLabel;

        if (gtmCategory && gtmAction && gtmLabel) {
            // TrackEvent on slideChange
            productSwiper.on('slideChange', function () {
                trackEvent(gtmCategory, gtmAction, gtmLabel);
            });
        }
    });
}
